module.exports = __webpack_public_path__ + "img/18.107d5ed8.jpg";